export const lightTokens = {
  background: {
    default: "#F6F8F3",
    surface: "#FFFFFF",
    elevated: "#EEF3EA"
  },
  text: {
    primary: "#111A14",
    secondary: "#43564B",
    disabled: "#6B7D72"
  },
  border: {
    default: "#D8E3D6",
    divider: "#D8E3D6"
  },
  action: {
    primary: "#315F46",
    primaryHover: "#244A36",
    primarySoft: "#DDEBDD",
    primaryContrast: "#FFFFFF",
    secondary: "#2F6F73",
    secondaryHover: "#24585C",
    secondarySoft: "#D8ECEB",
    secondaryContrast: "#FFFFFF",
    accent: "#A5653F",
    accentSoft: "#F2E3D8"
  },
  status: {
    success: "#047857",
    warning: "#B45309",
    error: "#B42318",
    info: "#2F6FA3"
  },
  map: {
    controlBackground: "#FFFFFF",
    controlForeground: "#101828"
  }
} as const;

export const darkTokens = {
  background: {
    default: "#0E1511",
    surface: "#16231B",
    elevated: "#203329"
  },
  text: {
    primary: "#F8FAFC",
    secondary: "#CCDACF",
    disabled: "#91A79A"
  },
  border: {
    default: "#31483B",
    divider: "#26382F"
  },
  action: {
    primary: "#63B57E",
    primaryHover: "#84D49E",
    primarySoft: "#1F3C2C",
    primaryContrast: "#0E1511",
    secondary: "#4FA3A0",
    secondaryHover: "#72BFBA",
    secondarySoft: "#173D3B",
    secondaryContrast: "#0E1511",
    accent: "#D19568",
    accentSoft: "#4B3325"
  },
  status: {
    success: "#6EE7B7",
    warning: "#FBBF24",
    error: "#FCA5A5",
    info: "#93C5FD"
  },
  map: {
    controlBackground: "#181A1D",
    controlForeground: "#F9FAFB"
  }
} as const;

export type GeoAnalyticsThemeMode = "light" | "dark";
export type GeoAnalyticsThemePreference = GeoAnalyticsThemeMode | "system";
export type GeoAnalyticsTokens = typeof lightTokens;
